import { TENANT_ROLES } from '@src/constants/user-roles-constants.js'

export const EXCLUDE_ROLES = [
  TENANT_ROLES.SECTION_ADMIN,
  TENANT_ROLES.SECTION_MODERATOR,
  TENANT_ROLES.CAMPUS_MODERATOR,
]
